module.exports = __webpack_public_path__ + "img/S__58384570.e6a3f9c5.jpg";